export default "A car has been finished!";